import React, { useState, useEffect } from 'react';

const COOKIE_CONSENT_KEY = 'truhail_cookie_consent';

type ConsentState = 'accepted' | 'rejected' | null;

function CookieConsent() {
    const [consentState, setConsentState] = useState<ConsentState>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        try {
            const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
            if (stored === 'accepted' || stored === 'rejected') {
                setConsentState(stored);
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }
        } catch (e) {
            // localStorage may be unavailable in private browsing mode
            console.warn('[CookieConsent] localStorage unavailable:', e);
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
        setConsentState('accepted');
        setIsVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
        setConsentState('rejected');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                backgroundColor: 'rgba(13, 13, 17, 0.97)',
                borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(12px)',
                padding: '16px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                flexWrap: 'wrap',
                fontFamily: "'Inter', sans-serif",
            }}
        >
            <div style={{ flex: 1, minWidth: '280px' }}>
                <p
                    style={{
                        color: '#E5E5EA',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        margin: 0,
                    }}
                >
                    We use cookies and similar technologies to improve your experience,
                    personalize content, and analyze platform usage, in compliance with
                    Applicable Data Protection Laws (including LGPD — Lei nº 13.709/2018).
                    See our{' '}
                    <a
                        href="/privacy-policy-subscriber"
                        style={{ color: '#00C2FF', textDecoration: 'underline' }}
                    >
                        Privacy Policy
                    </a>{' '}
                    and{' '}
                    <a
                        href="/terms-subscriber"
                        style={{ color: '#00C2FF', textDecoration: 'underline' }}
                    >
                        Terms &amp; Conditions
                    </a>{' '}
                    for details on how we protect your data. Learn more in our{' '}
                    <a
                        href="/cookies-rider"
                        style={{ color: '#00C2FF', textDecoration: 'underline' }}
                    >
                        Política de Cookies
                    </a>
                    .
                </p>
            </div>

            <div
                style={{
                    display: 'flex',
                    gap: '12px',
                    flexShrink: 0,
                }}
            >
                <button
                    onClick={handleReject}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        backgroundColor: 'transparent',
                        color: '#E5E5EA',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontFamily: "'Inter', sans-serif",
                        transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    Decline
                </button>
                <button
                    onClick={handleAccept}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: '#00C2FF',
                        color: '#0D0D11',
                        fontSize: '14px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontFamily: "'Inter', sans-serif",
                        transition: 'all 0.2s ease',
                        boxShadow: '0 0 15px rgba(0, 194, 255, 0.3)',
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#33CFFF';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#00C2FF';
                    }}
                >
                    Accept
                </button>
            </div>
        </div>
    );
}

export default CookieConsent;
